import { TemplateMapVariant, TemplateMapConfig } from '../types';
import { formatDate } from '../utils';

interface ClusterPopupOptions {
  leaves: GeoJSON.Feature[];
  pointCount: number;
  variant: TemplateMapVariant;
  config: TemplateMapConfig;
  templateId: string | undefined;
  styles: Record<string, string>;
  t: (key: string, fallback: string) => string;
}

const buildLeafHTML = (
  leaf: GeoJSON.Feature,
  variant: TemplateMapVariant,
  config: TemplateMapConfig,
  templateId: string | undefined,
  styles: Record<string, string>,
  t: (key: string, fallback: string) => string,
): string => {
  const p = leaf.properties;

  const title = variant === 'transport'
    ? [p?.bodytype, p?.carrying_capacity ? `${p.carrying_capacity} ${t('common.tons', 'т')}` : ''].filter(Boolean).join(', ')
    : p?.designation || p?.bodytype || '';

  const loadingAddress = p?.from_city || p?.address || '';
  const unloadingAddress = p?.to_city || p?.unloading_address || '';

  const dateFrom = variant === 'transport' ? p?.available_from : p?.loading_from;
  const dateTo = variant === 'transport' ? p?.available_to : p?.loading_to;
  const dateRange = [dateFrom ? formatDate(dateFrom) : '', dateTo ? formatDate(dateTo) : '']
    .filter(Boolean)
    .join(' – ');

  const price = p?.price && Number(p.price) !== 0
    ? `${p.price} ${p.currency || ''}`
    : t('common.priceOnRequest', 'Цена по запросу');

  const route = [loadingAddress, unloadingAddress].filter(Boolean).join(' → ');

  return `
    <div class="${styles.clusterItem}" onclick="window.open('${config.routes.search}?templateId=${templateId}&${config.itemIdParam}=${p?.id}', '_blank')">
      ${route ? `<div class="${styles.clusterItemTitle}">${route}</div>` : ''}
      ${dateRange ? `<div class="${styles.clusterItemInfo}">${dateRange}</div>` : ''}
      ${title ? `<div class="${styles.clusterItemInfo}">${title}</div>` : ''}
      <div class="${styles.clusterItemPrice}">${price}</div>
    </div>
  `;
};

export const buildClusterPopupHTML = ({
  leaves,
  pointCount,
  variant,
  config,
  templateId,
  styles,
  t,
}: ClusterPopupOptions): string => {
  const listHTML = leaves
    .map(leaf => buildLeafHTML(leaf, variant, config, templateId, styles, t))
    .join('');

  return `
    <div class="${styles.clusterPopup}">
      <div class="${styles.clusterPopupHeader}">${t('map.clusterItems', 'Объектов')}: ${pointCount}</div>
      <div class="${styles.clusterPopupList}">${listHTML}</div>
    </div>
  `;
};